import { Button, ButtonProps } from "@mui/material";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";

export type DropDownButtonProps = {
  display: string;
  handleClick?: (event: any) => void;
  fullWidth?: boolean;
  size?: "large" | "small";
  variant?: "text" | "contained";
  color?: "primary" | "secondary";
  colorLevel?: "light" | "main" | "dark";
};

export const DropDownButton = ({ size = "small", handleClick, display, fullWidth = false, variant = "text", color = "secondary" }: DropDownButtonProps) => {
  return (
    <Button
      fullWidth={fullWidth}
      sx={{
        padding: 0,
        fontSize: "1.5rem",
        fontWeight: 700,

        whiteSpace: "nowrap",
        "&:hover": {
          backgroundColor: "transparent",
        },
        "&.MuiButton-contained": {
          padding: "0.75rem 1.25rem",
          borderRadius: "50vh",
        },
        justifyContent: "space-between",
        "& .MuiSvgIcon-root": { marginLeft: "1.4375rem", fontSize: "32px" },
        ...(size == "small" && {
          fontSize: "1.0625rem",
          fontWeight: 500,
          "& .MuiSvgIcon-root": {
            fontSize: "inherit",
          },
        }),
      }}
      color={color}
      variant={variant}
      onClick={handleClick}
      disableElevation
      disableRipple
    >
      {display} <KeyboardArrowDownOutlinedIcon />
    </Button>
  );
};
